import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { TileDataUnion } from '../models/tile-data.model';
import * as TileActions from './tile.actions';
import { clearTileBatchQueue, tileLoad, tileLoadedFailure, tileLoadedSuccess } from './tile.actions';

export const tilesFeatureKey = 'tiles';

export interface TileState {
   data: TileDataUnion | null;
   callState: CallState;
}

export type TileStateKey = number | VerboseTileIds.previewTile | VerboseTileIds.fullscreenTile;
export enum VerboseTileIds {
   previewTile = -1,
   fullscreenTile = -2,
}

export interface TileLoadProps {
   dashboardTileId: TileStateKey;
   isFullscreen?: boolean;
   forceViewModeRecalculation?: boolean;
   pageSize?: number | null;
   pageNumber?: number | null;
}

export interface State {
   callState: CallState;
   tiles: { [key in TileStateKey]: TileState } | {};
   tileLoadBatchQueue: { [key in TileStateKey]: TileLoadProps } | {};
}

export const initialState: State = {
   callState: LoadingState.Init,
   tiles: {},
   tileLoadBatchQueue: {},
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),

   on(tileLoad, (state, action) => {
      return {
         ...state,
         tiles: {
            ...state.tiles,
            [action.dashboardTileId]: {
               ...state.tiles[action.dashboardTileId],
               callState: LoadingState.Loading,
            },
         },
         tileLoadBatchQueue: { ...state.tileLoadBatchQueue, [action.dashboardTileId]: { ...action } },
      };
   }),
   on(clearTileBatchQueue, (state, action) => {
      return {
         ...state,
         tileLoadBatchQueue: {},
      };
   }),
   on(tileLoadedSuccess, (state, action) => {
      return {
         ...state,
         tiles: {
            ...state.tiles,
            [action.dashboardTileId]: {
               ...state.tiles[action.dashboardTileId],
               data: action.tileData,
               callState: LoadingState.Loaded,
            },
         },
      };
   }),
   on(tileLoadedFailure, (state, action) => {
      return {
         ...state,
         tiles: {
            ...state.tiles,
            [action.dashboardTileId]: {
               ...state.tiles[action.dashboardTileId],
               callState: { error: action.error },
            },
         },
      };
   }),
   on(TileActions.deleteDashboardTileSuccess, (state, action) => {
      const tiles = { ...state.tiles };
      delete tiles[action.dashboardTileId];
      return {
         ...state,
         tiles,
      };
   })
);
